import '../plugins/ResponsiveHelper.js';

export default function initCategoryMenu() {
  const panel = document.querySelector('.collapsible-panel--category-menu');

  if (!panel) {
    return;
  }

  function toggle (visible) {
    const header = panel ? panel.querySelector('.header') : null;
    const body = panel ? panel.querySelector('.body') : null;
    if (!header) {
      return;
    }
    if (!body) {
      return;
    }

    const isVisible = body.classList.contains('show');
    if (isVisible !== visible) {
      header.click();
    }
  }
}
